import { __decorate } from "tslib";
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import ImageUtil from '@blade-sxp/portrait-management/utils/image-util';
import { Component, Vue, Ref, Prop } from 'vue-property-decorator';
import { Queue } from '@blade-sxp/portrait-management/utils/task-queue';
import { Scale } from '@blade/common/utils/auto-scale';
// 较长的宽度
// 用于方法图片匹配 以高度匹配的写死一个较长宽度
const longerWidth = 100000;
// 排队最大运行数量
const maxRunning = 4;
// 队列
const queue = new Queue(maxRunning);
let CombinedPicture = class CombinedPicture extends Vue {
    combinedImage;
    src;
    coordinates;
    maxWidth;
    maxHeight;
    disabled; // 失效状态
    queueing = false;
    // @Watch('src')
    // srcChange(val: string) {
    //   // this.queueingRun(val);
    // }
    mounted() {
        this.queueingRun();
    }
    beforeDestroy() {
        queue.remove(this.queueingTaskId);
    }
    mattingImages = [];
    queueingTaskId = undefined;
    /** 模糊尺寸 */
    get blurSize() {
        return this.privacyMode ? 6 : 0;
    }
    /** 隐私模式 */
    get privacyMode() {
        return localStorage.getItem('privacyMode') === 'true';
    }
    /** 排队运行 */
    async queueingRun(val) {
        if (!val)
            val = this.src;
        if (this.queueing || !val)
            return;
        const { conWidth, conHeight } = this.getConBox();
        if (conHeight && conWidth) {
            try {
                this.queueing = true;
                this.queueingTaskId = await queue.run(this.generateImages(val, conWidth, conHeight));
            }
            catch (error) {
                console.log('queueingRun err', error);
            }
            this.queueing = false;
        }
    }
    getCheck(val) {
        return val === 'INVALIDATING';
    }
    /** 获取容器盒子 */
    getConBox() {
        // 容器高度
        const conHeight = this.combinedImage?.clientHeight || this.maxHeight;
        // 容器宽度
        const conWidth = this.combinedImage?.clientWidth || this.maxWidth;
        return { conWidth, conHeight };
    }
    /** 生成图片 */
    async generateImages(src, conWidth, conHeight) {
        let mattingImages = await ImageUtil.mattingImage(src, this.coordinates);
        // 元素最大高度
        let itemMaxHeight = mattingImages.reduce((t, i) => (t = t > i.height ? t : i.height), 0);
        // 根据最大高度进行适配子图片宽度
        mattingImages = mattingImages.map((mi) => {
            if (mi.height !== itemMaxHeight) {
                let { width, height } = ImageUtil.containImage({
                    currentWidth: mi.width,
                    currentHeight: mi.height,
                    targetWidth: longerWidth,
                    targetHeight: itemMaxHeight,
                });
                mi.width = width;
                mi.height = height;
            }
            return mi;
        });
        // 元素的宽度和
        let itemSumWidth = mattingImages.reduce((t, i) => (t += i.width), 0);
        let { width, height } = ImageUtil.containImage({
            currentWidth: itemSumWidth,
            currentHeight: itemMaxHeight,
            targetWidth: conWidth,
            targetHeight: conHeight,
        });
        // 根据最大高度进行适配子图片宽度
        mattingImages = mattingImages.map((mi) => {
            mi.height = height;
            mi.width = (mi.width / itemSumWidth) * width;
            return mi;
        });
        this.mattingImages = mattingImages;
    }
    /** 唯一的key */
    blurPictureKey(mattingImage) {
        return `cp-` + mattingImage.url;
    }
    /** 图片增加样式 */
    blurPictureStyle(mattingImage) {
        return `width:${(Scale * mattingImage.width).toFixed(0)}px;height:${(Scale * mattingImage.height).toFixed(0)}px`;
    }
};
__decorate([
    Ref()
], CombinedPicture.prototype, "combinedImage", void 0);
__decorate([
    Prop()
], CombinedPicture.prototype, "src", void 0);
__decorate([
    Prop()
], CombinedPicture.prototype, "coordinates", void 0);
__decorate([
    Prop({ default: 0 })
], CombinedPicture.prototype, "maxWidth", void 0);
__decorate([
    Prop({ default: 0 })
], CombinedPicture.prototype, "maxHeight", void 0);
__decorate([
    Prop()
], CombinedPicture.prototype, "disabled", void 0);
CombinedPicture = __decorate([
    Component({
        components: { BlurPicture },
    })
], CombinedPicture);
export default CombinedPicture;
